import createIcon from '../../createIcon';

/**
 * @component @name Woman2
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTMuOTQgOC4zMUMxMy42MiA3LjUyIDEyLjg1IDcgMTIgN0MxMS4xNSA3IDEwLjM4IDcuNTIgMTAuMDYgOC4zMUw3IDE2SDEwLjVWMjJIMTMuNVYxNkgxN0wxMy45NCA4LjMxWiIgZmlsbD0iYmxhY2siLz4KPHBhdGggZD0iTTEyIDZDMTMuMTA0NiA2IDE0IDUuMTA0NTcgMTQgNEMxNCAyLjg5NTQzIDEzLjEwNDYgMiAxMiAyQzEwLjg5NTQgMiAxMCAyLjg5NTQzIDEwIDRDMTAgNS4xMDQ1NyAxMC44OTU0IDYgMTIgNloiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Woman2 = createIcon('Woman2', [
  [
    'path',
    {
      d: 'M13.94 8.31C13.62 7.52 12.85 7 12 7C11.15 7 10.38 7.52 10.06 8.31L7 16H10.5V22H13.5V16H17L13.94 8.31Z',
      key: 't716x2',
    },
  ],
  [
    'path',
    {
      d: 'M12 6C13.1046 6 14 5.10457 14 4C14 2.89543 13.1046 2 12 2C10.8954 2 10 2.89543 10 4C10 5.10457 10.8954 6 12 6Z',
      key: '1cb55s',
    },
  ],
]);

export default Woman2;
